// extracted by mini-css-extract-plugin
export default {"addInstrumentDialog":"addInstrumentDialog-WL4_V","title":"title-PHuoI","footer":"footer-mxw3L","button":"button-cU2Sq"};